import { render, staticRenderFns } from "./FeaturedBannersPagesContainer.vue?vue&type=template&id=34d06587&"
import script from "./FeaturedBannersPagesContainer.vue?vue&type=script&lang=js&"
export * from "./FeaturedBannersPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports